// extracted by mini-css-extract-plugin
export default {"grid":"SectionFive-module--grid--kV0Sc","storeCard":"SectionFive-module--storeCard--z0XFh"};